"use client"
import { Paper, Typography, Divider, Button, Grid, alpha, useTheme } from "@mui/material"
import {
  Add as AddIcon,
  Person as PersonIcon,
  CreditCard as CreditCardIcon,
  BarChart as BarChartIcon,
} from "@mui/icons-material"
import { Link } from "react-router-dom"

const QuickActions = () => {
  const theme = useTheme()

  const actions = [
    {
      title: "Add Customer",
      icon: <PersonIcon />,
      color: theme.palette.primary.main,
      path: "/customers/create",
    },
    {
      title: "Add Credits",
      icon: <CreditCardIcon />,
      color: theme.palette.success.main,
      path: "/credits",
    },
    {
      title: "Generate Report",
      icon: <BarChartIcon />,
      color: theme.palette.info.main,
      path: "/reports",
    },
  ]

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        borderRadius: 2,
        height: "100%",
        boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)",
      }}
    >
      <Typography variant="h6" gutterBottom>
        Quick Actions
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        {actions.map((action, index) => (
          <Grid item xs={12} key={index}>
            <Button
              component={Link}
              to={action.path}
              variant="outlined"
              fullWidth
              startIcon={action.icon}
              sx={{
                py: 1.5,
                justifyContent: "flex-start",
                color: action.color,
                borderColor: alpha(action.color, 0.5),
                "&:hover": {
                  borderColor: action.color,
                  backgroundColor: alpha(action.color, 0.05),
                },
              }}
            >
              {action.title}
            </Button>
          </Grid>
        ))}

        <Grid item xs={12}>
          <Button variant="contained" fullWidth startIcon={<AddIcon />} sx={{ py: 1.5 }}>
            New Action
          </Button>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default QuickActions

